import React from 'react';
import { MdOutlineWorkHistory } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import { IoTimer } from "react-icons/io5";
import { FaCalendarTimes } from 'react-icons/fa';
import './layout.css';

const TimeLayout = ({ children }) => {
  return (
    <div className='container-fluid time-layout-wrapper'>
      <h1 className="layout-title">
        <FaCalendarTimes className="leave-policy-icon" />
        My Timings History
      </h1>

      {/* Hr ka spacing tight kiya hai */}
      <hr style={{ marginTop: '0px', marginBottom: '12px', borderColor: '#bbdefb' }} />

      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="time-history-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/time-history"
              >
                <MdOutlineWorkHistory className="nav-icon" /> Current Month
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="timings-history-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/timings-history"
              >
                <IoTimer className="nav-icon" /> Timing History
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children} {/* Render the child components here */}
        </div>
      </section>
    </div>
  );
};

export default TimeLayout;